import Hand from 'play_perfect/Hand'
import Game from './Game'

/**
 *  there is a global WASM  (captital) that actually does all the work
 *  each game class instance needs to know about it. as it calls methods on it.
 * once the wasm is set for a game, it is stored in Machine.wasm
 *  games maintain state, so well, we can switch back-n-forth
 *  display stuff is NOT in the game.
 *
 */

class VPMachine {

  constructor(){
    this.wasm
    this.currentGame
    this.games = {}
  }

  static availableGames(){
    return {
       BP4: {},
       DW9: {},
       DB7: {},
       DD5: {},
       JB1: {}
    }
  }

  changeGame(_game) {
    if (this.currentGame == _game) return

    const gameConfig = VPMachine.availableGames(_game)
    if ( !gameConfig ) {
      debug.log("No game on machine", _game)
      return
    }

    const lastGame = this.games[this.currentGame]
    const cachedGame = this.games[_game]

    if (cachedGame) {
      debug.log('vpmachine using cached game', _game)
      cachedGame.wasm = WASM(_game)
      this.currentGame = _game
      // this.game.handLastEvaluated COULD BE SET...
    } else {
      debug.log('vpmachine building new', _game)
      this.games[_game] = new Game(WASM(_game), _game, gameConfig)
      this.currentGame = _game
    }

    if (lastGame && lastGame.hand) {
      debug.log('vpmachine changeGame copying hand')
      this.game.setHand(lastGame.hand)
    }

    // if (this.wasm) {
    //   debug.log('machine calling freeMemory')
    //   this.wasm.freeMemory()
    // }

    return true

  }

  ready(){
    return this.currentGame && this.game && this.game.ready()
  }

  get game(){
    //if (!this.currentGame) return
    return this.games[this.currentGame]
  }



}

export default VPMachine

